/**
 * 创建人：yuanjs
 * 时间：2019-7-01
 * 描述：用户角色切换列表
 * 使用说明: 参考 sw-user-or-role 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';


/**
 * 用户角色切换列表 sw-user-or-role
 */
@Component({
  selector: 'sw-user-or-role',
  templateUrl: './sw-user-or-role.component.html',
  styleUrls: ['./sw-user-or-role.component.css']
})
export class SwUserOrRoleComponent implements OnInit {

  /**
   * 是否展示左侧菜单
   * @ignore
   */
  showLeft:boolean = true  

  /**
   * 选中角色 还是用户
   * @ignore
   */
  userRole: boolean = false;

  /**
   * 用户列表
   * @ignore
   */
  userTree:any = [];

  /**
   * 角色列表
   * @ignore
   */
  roleTree:any = [];

  /**
   * 页面选中的角色
   * @ignore
   */
  checkedRole; 

  /**
   * 页面选中的用户
   * @ignore
   */
  checkedUser; 

    /**
   * 是否显示用户列表
   */
  @Input() isShowUser:boolean=true;  

  /**
   * 选中用户事件 抛出
   */
  @Output() votedUser = new EventEmitter();  

  /**
   * 是否有搜索功能
   */
  @Input() isSearch:boolean=false;  

  /**
   * 搜索功能的初始用户列表
   */
  initUser:any[] 

  /**
   * 搜索功能的初始角色列表
   */
  initRole:any[] 

  /**
   * 搜索功能的搜索内容
   */
  searchWord:string

  /**
   * 选中角色事件 抛出
   */
  @Output() votedRole = new EventEmitter();
  @Output() isShowLeft = new EventEmitter();

  /**
   * @ignore
   * @param service 
   * @param systemId 
   */
  constructor(
    private service : BdpService,
    private systemId:SystemIdService
    ) { }

  /**
   * @ignore
   */
  ngOnInit() {
    this.location()
  }

  /**
   * @ignore
   */
  location(){
    let params = { "param": { pageSize: 0,systemId:this.systemId.getSystemId(),isAdminQuery:true }, "entity": {} }
    this.service.getUserService().queryUserPageList(params).subscribe(data => {
        if (data["code"] == 200) {
          let arr = [];
          data["data"]["records"].forEach(e => {  //格式化数据
            if(e.status && e.type == 1){ //如果该用户启用且是系统用户
              arr.push({ id: e.userId, text: e.displayName, pId: 'Yiji' })
            }
          });
          this.userTree = arr;
          this.initUser = JSON.parse(JSON.stringify(arr))
        }
      })
    let param =  {"param":{pageSize:0,isAdminQuery:true}, "entity":{systemId:this.systemId.getSystemId()}};//参数
    this.service.getRoleService().queryRolePageList(param).subscribe(data=>{
      if(data["code"] == 200){
        let arr = [];
        data["data"]["records"].forEach(e => {  //格式化数据
          arr.push({ id: e.roleId, text: e.roleName, pId: 'Yiji',isAdmin:e.isAdmin })
        });
        this.roleTree = arr;
        this.initRole = JSON.parse(JSON.stringify(arr))
      }
    })
  }

  /**
   * @ignore
   * @param showLeft 
   */
  showStyle(showLeft) {
    this.showLeft=!showLeft;
    this.isShowLeft.emit(this.showLeft)
  }

  /**
   * @ignore
   * 点击某个用户或角色
   * @param event 
   */
  onVotedUser(event){
    this.checkedUser = event;
    this.checkedRole = undefined;
    this.votedUser.emit(event)
  }

  /**
   * @ignore
   * @param event 
   */
  onVotedRole(event){
    this.checkedRole = event;
    this.checkedUser = undefined;
    this.votedRole.emit(event)
  }
  //enter事件
  keydown($event) {
   let  keyCode = $event.keyCode || $event.which;
    if(keyCode == 13){
       this.search()
    }
  }

  //点击搜索
  search(){
    if(this.userRole){  //为true的时候展示用户
      if(this.searchWord){
        this.userTree = this.initUser.filter(item=>item.text.indexOf(this.searchWord)>=0)
      } else {
        this.userTree = JSON.parse(JSON.stringify(this.initUser))
      }
      
    } else {  //搜索角色
      if(this.searchWord){
        this.roleTree = this.initRole.filter(item=>item.text.indexOf(this.searchWord)>=0)
      } else {
        this.roleTree = JSON.parse(JSON.stringify(this.initRole))
      }
    }
  }
}
